import { isUnknownDictionary, typeCheck } from "@knyt/artisan";
import { setSingularElementAttributes } from "./setSingularElementAttributes.js";
import { setSingularElementStyleProperty } from "./setSingularElementStyleProperty.js";
// NOTE: This shouldn't be exported,
// this is just for module level type checking.
function isStyleObject(value) {
    return isUnknownDictionary(value);
}
export function isNonNullableStyleInput(value) {
    return isStyleObject(value) || typeof value === "string";
}
export function setSingularElementStyle(element, prevStyle, nextStyle) {
    if (typeof nextStyle === "string") {
        const prevAttrs = typeof prevStyle === "string" ? { style: prevStyle } : undefined;
        const nextAttrs = { style: nextStyle };
        setSingularElementAttributes(element, prevAttrs, nextAttrs);
        return;
    }
    if (isStyleObject(nextStyle)) {
        const prevStyleValue = isStyleObject(prevStyle) ? prevStyle : undefined;
        setSingularElementStyleProperty(element, prevStyleValue, nextStyle);
        return;
    }
    // TODO: Remove in production
    typeCheck(typeCheck.identify(nextStyle));
    throw new TypeError(`Invalid style input: ${typeof nextStyle}`);
}
